import { Component, Input } from '@angular/core';

import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';

@Component({
  selector: 'app-success-layout',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessLayoutComponent {
  @Input() public desktopBackgroundImage: string;
  @Input() public icon = VtmnPlayIconTypeEnum.CheckCircle;
  @Input() public mobileBackgroundImage: string;
  @Input() public title: string;

  public readonly logo = LogoTypeEnum.Light;
  public readonly mdScreenSize = `(min-width:${BreakpointWidthEnum.MD}px)`;
}
